import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

const Manifesto: React.FC = () => {
  const { t } = useTranslation();

  const articles = [
    {
      number: 'I',
      title: t('manifesto.article1.title'),
      content: t('manifesto.article1.content'),
    },
    {
      number: 'II',
      title: t('manifesto.article2.title'),
      content: t('manifesto.article2.content'),
    },
    {
      number: 'III',
      title: t('manifesto.article3.title'),
      content: t('manifesto.article3.content'),
    },
    {
      number: 'IV',
      title: t('manifesto.article4.title'),
      content: t('manifesto.article4.content'),
    },
    {
      number: 'V',
      title: t('manifesto.article5.title'),
      content: t('manifesto.article5.content'),
    },
  ];

  return (
    <>
      <Helmet>
        <title>Manifesto 1943 | Born in YU Principles</title>
        <meta name="description" content="Read the Born in YU Manifesto 1943, outlining our principles of celebrating Yugoslav heritage, brutalist design, and cultural preservation." />
        <link rel="canonical" href="https://borninyu.com/manifesto" />
      </Helmet>
      <div className="min-h-screen bg-white">
        {/* Header Section */}
        <div className="border-b-4 border-black bg-white p-8 md:p-16">
        <div className="max-w-5xl mx-auto">
          {/* Document ID */}
          <div className="flex items-center justify-between mb-8">
            <div className="text-[10px] font-bold uppercase tracking-widest">
              {t('manifesto.docId')}: YU-MAN-1943
            </div>
            <div className="border-3 border-black px-4 py-2 bg-[#C41E3A] text-white text-xs font-black uppercase tracking-wider">
              {t('manifesto.classified')}
            </div>
          </div>

          {/* Title */}
          <h1 className="text-5xl md:text-7xl font-black uppercase leading-none mb-4 tracking-tighter">
            {t('manifesto.title')}
          </h1>

          {/* Subtitle */}
          <div className="text-lg md:text-2xl font-bold uppercase tracking-tight text-gray-700 mb-8">
            {t('manifesto.subtitle')}
          </div>

          {/* Date & Stamp */}
          <div className="flex items-center gap-8">
            <div className="text-sm font-bold uppercase">{t('manifesto.issued')}: NOV 29 1943</div>
            <div className="border-2 border-black px-3 py-1 text-xs font-black uppercase">
              {t('manifesto.approved')}
            </div>
            <div className="border-2 border-black px-3 py-1 text-xs font-black uppercase">
              {t('manifesto.verified')}
            </div>
          </div>
        </div>
      </div>

      {/* Articles Section */}
      <div className="max-w-5xl mx-auto px-8 py-16 md:px-16">
        {articles.map((article, index) => (
          <React.Fragment key={article.number}>
            {/* Article */}
            <div className="mb-16">
              {/* Article Number & Title */}
              <div className="flex items-start gap-6 mb-6">
                <div className="text-6xl md:text-8xl font-black text-[#C41E3A] leading-none">
                  {article.number}
                </div>
                <div className="flex-1 pt-2">
                  <h2 className="text-2xl md:text-4xl font-black uppercase leading-tight tracking-tighter">
                    {article.title}
                  </h2>
                </div>
              </div>

              {/* Article Content */}
              <div className="pl-0 md:pl-24">
                <p className="text-base md:text-lg leading-relaxed font-medium border-l-4 border-black pl-6">
                  {article.content}
                </p>
              </div>
            </div>

            {/* Red Star Divider */}
            {index < articles.length - 1 && (
              <div className="flex justify-center my-12">
                <svg width="40" height="40" viewBox="0 0 40 40" className="text-[#C41E3A]">
                  <path
                    d="M20,4 L23,16 L35,16 L25,24 L29,36 L20,28 L11,36 L15,24 L5,16 L17,16 Z"
                    fill="currentColor"
                    stroke="#000"
                    strokeWidth="1"
                  />
                </svg>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Footer Stamp Section */}
      <div className="border-t-4 border-black bg-gray-100 p-8">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div className="text-xs font-bold uppercase">{t('manifesto.footer.authority')}</div>
            <div className="flex gap-4 flex-wrap">
              <div className="border-2 border-black bg-white px-3 py-1 text-[10px] font-black uppercase">
                {t('manifesto.footer.official')}
              </div>
              <div className="border-2 border-black bg-white px-3 py-1 text-[10px] font-black uppercase">
                {t('manifesto.footer.declassified')}
              </div>
              <div className="border-2 border-black bg-[#C41E3A] text-white px-3 py-1 text-[10px] font-black uppercase">
                {t('manifesto.footer.forPosterity')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Manifesto;
